import { render } from "./RegistersSection.vue?vue&type=template&id=2fc0af26"
import script from "./RegistersSection.vue?vue&type=script&lang=js"
export * from "./RegistersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__